import { FC, ReactElement } from 'react';

import { ConfirmDialog } from '../dialog';
import { useConfirmService } from '../service';

export interface IConfirmProps {
  children: ReactElement;
  color?: 'primary' | 'secondary';
}

export const ConfirmProvider: FC<IConfirmProps> = props => {
  const { children, color = 'primary' } = props;
  const { confirmConfig, closeConfirm } = useConfirmService();

  return (
    <>
      {children}

      {confirmConfig && (
        <ConfirmDialog color={color} onClose={closeConfirm} {...confirmConfig}>
          {confirmConfig?.message}
        </ConfirmDialog>
      )}
    </>
  );
};
